import { StyleSheet, View } from 'react-native';
import { useTranslation } from 'react-i18next';

import { Text, spacing, AcceptIcon, CancelIcon, useLayoutDimensions } from '@pletly/ui';
import { getName } from '@pletly/shared';

import { MembersTable } from '../../../components/MembersTable';
import { useGetInvitationsFromFamilyCaregiversQuery } from '../__generated__/invitationsFromFamilyCaregivers.generated';

import { withTranslation } from '../../../../locales/hoc';
import { useInvitationAction } from './useInvitationAction';
import { ActionButton } from './ActionButton';

export const InvitationsFromFamilyCaregivers = withTranslation(
	({ organisationUuid }: { organisationUuid: string }) => {
		const { t } = useTranslation();
		const { width: actionsWidth, onLayout } = useLayoutDimensions();
		const { data } = useGetInvitationsFromFamilyCaregiversQuery({
			variables: { organisationUuid },
		});

		const { handleInvitationAction } = useInvitationAction();

		if (!data) {
			return null;
		}

		return (
			<MembersTable
				data={data.invitationsFromFamilyCaregivers}
				rowActionsWidth={actionsWidth}
				columnsConfig={[
					{
						name: t('table.header.requester'),
						renderCell: ({ row: { fromUser } }) => <Text category="p1">{getName(fromUser)}</Text>,
					},
					{
						name: t('table.header.care-recipient'),
						renderCell: ({ row: { toUser } }) => <Text category="p1">{getName(toUser)}</Text>,
					},
				]}
				renderRowActions={({ row: { id, fromUser, toUser } }) => (
					<View style={styles.actions} onLayout={onLayout}>
						<ActionButton
							onPress={handleInvitationAction(
								{ id, requesterName: getName(fromUser), careRecipientName: getName(toUser) },
								'accept',
							)}
							label={t('table.actions.accept')}
							Icon={AcceptIcon}
						/>
						<ActionButton
							onPress={handleInvitationAction(
								{ id, requesterName: getName(fromUser), careRecipientName: getName(toUser) },
								'reject',
							)}
							label={t('table.actions.reject')}
							Icon={CancelIcon}
							color="danger"
						/>
					</View>
				)}
			/>
		);
	},
);

const styles = StyleSheet.create({
	actions: {
		flexDirection: 'row',
		alignItems: 'center',
		gap: spacing(),
	},
});
